import React from 'react';
import PropTypes from 'prop-types';
import { LabelWrapper, PreLabelContainer } from './styles';

const Label = ({
  label,
  color,
  size,
  weight,
  margin,
  withCursor,
  lineHeight,
  alignSelf,
  isTitleNarrowMedium,
  noAlign,
  width,
  height,
  textAlignment,
  preLabel,
  isCapitalize,
  block,
  font,
  letterSpacing,
  className,
}) =>
  (
    <LabelWrapper
      block={block}
      withCursor={withCursor}
      color={color}
      size={size}
      weight={weight}
      margin={margin}
      lineHeight={lineHeight}
      alignSelf={alignSelf}
      isTitleNarrowMedium={isTitleNarrowMedium}
      noAlign={noAlign}
      width={width}
      height={height}
      textAlignment={textAlignment}
      isCapitalize={isCapitalize}
      font={font}
      letterSpacing={letterSpacing}
      className={className}
    >
      {preLabel &&
      <PreLabelContainer>
        {preLabel}
      </PreLabelContainer>
    }
      {label}
    </LabelWrapper>
  );

Label.propTypes = {
  block: PropTypes.bool,
  preLabel: PropTypes.any,
  label: PropTypes.any,
  color: PropTypes.string,
  size: PropTypes.any,
  weight: PropTypes.string,
  margin: PropTypes.any,
  withCursor: PropTypes.bool,
  noAlign: PropTypes.bool,
  lineHeight: PropTypes.number,
  alignSelf: PropTypes.string,
  isTitleNarrowMedium: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.any,
  textAlignment: PropTypes.string,
  isCapitalize: PropTypes.bool,
  font: PropTypes.string,
  letterSpacing: PropTypes.string,
  className: PropTypes.string,
};


export default Label;



// WEBPACK FOOTER //
// ./src/components/shared/Label/index.js